import Content1 from "../../../assets/images/projects/blibli-4-you/Content1.png";
import Content2 from "../../../assets/images/projects/blibli-4-you/Content2-transparent.png";
import Content3 from "../../../assets/images/projects/blibli-4-you/Content3.png";
import Content4 from "../../../assets/images/projects/blibli-4-you/Content4.png";
import Content5 from "../../../assets/images/projects/blibli-4-you/Content5.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Blibli 4 You",
  timeline: "24 hours",
  context:
    "Blibli Internal Hackathon with Startup theme (Yes the popular K-drama). The idea topic was variant and we can chose the team; We are challenged in 24 hours to make an idea for a delightful experiences in terms of Engagement. It's been a delightful experiences for us to learn and grow as an individual and team.",
  team: [
    "Freddy Albert Sanjaya - UX designer & project lead",
    "Glenn Filbert - UI designer & illustrator",
    "Goldwin Djapar - developer",
    "Wendy Yanto - developer",
  ],
  thumbnail: "",
  contents: [
    {
      left: {
        title: "Background",
        content: (
          <div>
            <p>
              Pandemic disconnect all of us and it changes many things. One of
              the kind that changes in our behaviour, is gifting. Based on
              Google Data, Global searches for “online gift” increased by 80% in
              2020 compared to 2019. Not only that, the desire to give has
              expanded beyond the typical special occasions — like birthdays and
              holidays — and beyond immediate family or social circle to the
              wider community. While people are getting more detached and
              isolated, our urge to reconnect as social creature increases some
              solves this through chatting and meeting each other, some solve
              this through gifting. Also, pandemic creates concern on gifting
              manually, since there's going to be a lot risk on catching
              unwanted virus through many point on touch (buying offline, manual
              wrapping, sending to receiver, etc.)
            </p>
            <p>
              <strong>
                How might we serve the needs of customer right now from offline
                experience to online digital platform in gifting?
              </strong>
            </p>
          </div>
        ),
      },
      bottomImage: "",
    },
    {
      left: {
        title: "What we did",
        content: (
          <div>
            We tried to do brainstorming for the features: what can we bring for
            the business, technolody, design, and how we presented it by
            creating the seamless flow wireframe in <strong>Miro</strong> and
            turn it into delightful user interfaces in <strong>Figma</strong>{" "}
            for the Hackathon.
            <p>
              Also, in our restricted time for 24 hours leads us to have an
              unique approach to validation the needs of the customer; we used
              Instastory. From the survey, we collected 234 participants and
              found interesting data: 191 people ever shop in ecommerce for
              gifts which means around 81,6% is our potential user on this gift
              feature 211 (90%) from 234 willing to try gift feature in
              ecommerce And we can estimate 64,9% people shop in ecommerce at
              least 1 in a month. This data might helps us to continue forward
              on the giving feature: Blibli4You
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content1} width="100%" />,
      },
      bottomImage: Content3,
    },
    {
      left: {
        title: "",
        content: "",
      },
      right: {
        title: "",
        content: "",
      },
      bottomImage: Content4,
    },
    {
      left: {
        title: "What we offered",
        content: (
          <div>
            We provide personalize gifts feature with customize theme and design
            for the gift wrap and wish note for the receiver gift. From
            entrepreneur.com on the ongoing gift idea, the revenue of the
            industry is expected to reach $77 billion. Second is the experiences
            itself that we will show on the demo, we believe the delightful
            experience with interactive illustration on the giving feature will
            engages more for sender and receiver. On our flow we give the
            receiver to follow-through the delight experiences in confirmation,
            and to track delivery until the user receive the gift whether it's
            for holiday eves, birthday, promps, bridal; Blibli support to
            celebrate with the customers.
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content2} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "Business Projection",
        content: (
          <div>
            I would like to project the business by the ecommerce that has been
            providing this gift features/wrapping: John's Crazy Socks. It has
            giving feature and personalized gifts which many people favor. As we
            can see on the mobile version John’s Crazy Socks’ led to Annual
            revenue of over $4 million with year-over-year boosts in CVR (15%),
            total sales (251%) and returning customer rate (2,067%) On this
            eccomerce that only sells shocks. Imagine, what it will be if it is
            in Blibli?
          </div>
        ),
      },
      right: {
        title: "",
        content: (
          <div>
            <p>Let's take there are 10.000 active user.</p>
            <p>
              10.000 x 90% = 9.000. The 9.000 willing to buy RP100.000 = GMV
              900.000.000/month (at least one in one month)
            </p>
            <p>
              Then according to the research “Social Influence and Reciprocity
              in Online Gift Giving” by René F. Kizilcec, Eytan Bakshy, Dean
              Eckles, Moira Burke: highly 56% chances customer would like to
              give a gift in the future on the social platform so there might
              chances 9.000 x 56% = 5.040 potential customer.
            </p>
            <p>PLUS FOR THE WRAPPING MAYBE WE CAN MONETIZE</p>
            <p>Amazon: $5.21 = around 70.000IDR</p>
            <p>John’s socks: $4.50 = around 65.000IDR</p>
            <p>
              Let’s take the middle of it so from the GMV that projected, we can
              get <strong>Rp585.000.000/month</strong>
            </p>
          </div>
        ),
      },
      bottomImage: "",
    },
    {
      left: {
        title: "Final Prototype",
        content: (
          <div>
            In the pitching for around 5 minutes I presented the idea of the
            product and then Goldwin conducted the demo. There were positive
            feedbacks and questions from the Jury. And on the end of the session
            we got the best presentation for the Blibli Hackathon 2020! It's
            amazing to have the experiences there and we learned things in
            there. You can access the prototype{" "}
            <a
              href="http://blibli-gift.netlify.app/"
              target="_blank"
              rel="noreferrer noopener"
              style={{ color: "var(--project-link)" }}
            >
              here
            </a>
            <p>
              Disclaimer: for this prototype is only for depiction and we
              restricted few flow for the sender screen.
            </p>
            <p>
              Special thanks to Glenn for providing the asset illustrations.
            </p>
          </div>
        ),
      },
      bottomImage: Content5,
    },
  ],
} as ProjectDetailProps;
